import React from "react";

const Form = ({montant, setMontant, imposable, setImposable, installation, setInstallation, setResultat}) =>
    <div>
        <div className="mb-3" style={{ marginBottom: "15px"}}>
            <label htmlFor="montant" className="form-label titre-question">1- Mon installation</label>
            <div className="question">
                <div className="form-check">
                    <input className="form-check-input" type="radio" id="eauchaude" value="1" checked={installation === "1"}
                        onChange={(e) => {
                            setInstallation(e.target.value)
                            // Réinitialisation du résultat
                            setResultat()
                        }}/>
                    <span className="form-check-label" htmlFor="eauchaude">
                    Panneaux solaires thermiques pour le chauffe-eau
                    </span>
                </div>
                <div className="form-check">
                    <input className="form-check-input" type="radio" id="chauffage" value="2" checked={installation === "2"}
                        onChange={(e) => {
                            setInstallation(e.target.value)
                            // Réinitialisation du résultat
                            setResultat()
                        }}/>
                    <span className="form-check-label" htmlFor="chauffage" >
                    Panneaux solaires thermiques pour le chauffage & chauffe-eau
                    </span>
                </div>
            </div>

        </div>
        <div className="mb-3" style={{ marginBottom: "15px"}}>
            <label htmlFor="montant" className="form-label titre-question">2- Montant TTC de mes travaux en €</label>
            <div className="question">
                <div className="complement">Equipements et installation (se référer au devis que vous devrez fournir lors de votre demande)</div>
                <input type="number" className="form-control" id="montant" value={montant} 
                    onChange={(e) => {
                        let montant = Math.round((Number(e.target.value)+Number.EPSILON)*100)/100
                        if (montant < 0) montant = 0;
                        if (montant === 0) montant = "";

                        // Arrondi à 2 décimales
                        setMontant(montant)
                        // Réinitialisation du résultat
                        setResultat()
                    }}/>
            </div>
        </div>
        <div className="mb-3" style={{ marginBottom: "15px"}}>
            <label className="titre-question">3- Mes informations personnelles</label>
            <div className="question">
                <div className="form-check">
                    <input className="form-check-input" type="radio" id="imposable" value="oui" checked={imposable === "oui"}
                        onChange={(e) => {
                            setImposable(e.target.value)
                            // Réinitialisation du résultat
                            setResultat()
                        }}/>
                    <span className="form-check-label" htmlFor="imposable">
                    Je fais partie d’un foyer fiscal imposable
                    </span>
                </div>
                <div className="form-check">
                    <input className="form-check-input" type="radio" id="nonimposable" value="non" checked={imposable === "non"}
                        onChange={(e) => {
                            setImposable(e.target.value)
                            // Réinitialisation du résultat
                            setResultat()
                        }}/>
                    <span className="form-check-label" htmlFor="nonimposable">
                    Je fais partie d’un foyer fiscal non imposable.
                    </span>
                </div>
            </div>
        </div>
    </div>

    export default Form